import dayjs from 'dayjs'
import { FC, useCallback } from 'react'

import { NotificationApiType } from '@/api/models/notifications/lib/notifications.types'
import { cn } from '@/app/utils'
import { AppTooltip } from '@/components/shared/tooltip'

import NotificationCardIcon from './NotificationCardIcon'

type Props = {
  item: NotificationApiType
  className?: string
  onMarkAsRead: (id: string) => void
}

const createDateFormats = {
  sameDay: 'HH:mm',
  lastDay: 'D MMMM',
  lastWeek: 'D MMMM',
  sameElse: 'D MMMM'
}

const NotificationCardHead: FC<Props> = ({ item, className, onMarkAsRead }) => {
  const isNew = !item.isRead

  const handleMarkAsRead = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      onMarkAsRead(item.id)
    },
    [item.id, onMarkAsRead]
  )

  return (
    <div className={cn('flex', className)}>
      {isNew && (
        <AppTooltip
          aria-label="Пометить уведомление прочитанным"
          offset={{ mainAxis: -6, crossAxis: -24 }}
          placement="bottom-start"
          text="Пометить прочитанным"
          renderActivator={props => (
            <button
              {...props}
              className={cn(
                '-ml-10 flex h-32 w-28 shrink-0 justify-center pt-12',
                'lg:-ml-8 lg:h-24 lg:w-22 lg:pt-9',
                'sm:-ml-7 sm:h-20 sm:w-20 sm:pt-7'
              )}
              onClick={handleMarkAsRead}
            >
              <div
                className={cn(
                  'h-8 w-8 rounded-full bg-bronze-70',
                  'lg:h-6 lg:w-6'
                )}
              ></div>
            </button>
          )}
        />
      )}

      <div className="shrink-0">
        <NotificationCardIcon item={item} />
      </div>

      <h3
        className={cn(
          'ml-8 pr-8 pt-2 font-bold text-black text-20',
          'lg:!leading-[20px] lg:text-16',
          'sm:ml-4 sm:pt-0'
        )}
      >
        {item.title || 'Объявление'}
      </h3>

      <div
        className={cn(
          'ml-auto shrink-0 pt-4 font-pro text-grey-70 text-16',
          'lg:text-12',
          'sm:pt-2'
        )}
      >
        {dayjs(item.createdAt).calendar(null, createDateFormats)}
      </div>
    </div>
  )
}

export default NotificationCardHead
